import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";

export default function DressCode() {
  const { t } = useLang();

  return (
    <section
      id="dresscode"
      className="relative py-24 md:py-40 px-6 md:px-12"
      data-testid="dresscode-section"
    >
      <div className="max-w-4xl mx-auto text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9 }}
          className="text-xs uppercase tracking-[0.4em] text-burgundy mb-4"
        >
          {t.dressCode.overline}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 1.1, delay: 0.1 }}
          className="font-serif font-light text-4xl md:text-6xl text-ink mb-16 leading-tight"
        >
          {t.dressCode.title}
        </motion.h2>

        {/* Gradient strip */}
        <motion.div
          initial={{ opacity: 0, scaleX: 0 }}
          whileInView={{ opacity: 1, scaleX: 1 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
          className="relative mx-auto max-w-3xl origin-center"
          data-testid="dresscode-gradient"
        >
          <div
            className="h-16 md:h-20 rounded-full shadow-[0_10px_40px_rgba(26,21,20,0.25)]"
            style={{
              background:
                "linear-gradient(90deg, #9B2434 0%, #7B1F2A 18%, #5C1820 34%, #8B5A2B 58%, #4A2C1A 78%, #1A1514 100%)",
            }}
          />
          <div className="pointer-events-none absolute inset-0 rounded-full border border-ivory/20" />
        </motion.div>

        {/* Labels under the strip */}
        <div className="relative mx-auto max-w-3xl mt-6 grid grid-cols-3 text-xs md:text-sm uppercase tracking-[0.3em]">
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.4 }}
            className="text-left"
            style={{ color: "#7B1F2A" }}
            data-testid="dresscode-label-red"
          >
            {t.dressCode.swatches.burgundy}
          </motion.span>
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.55 }}
            className="text-center"
            style={{ color: "#8B5A2B" }}
            data-testid="dresscode-label-brown"
          >
            {t.dressCode.swatches.brown}
          </motion.span>
          <motion.span
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.9, delay: 0.7 }}
            className="text-right"
            style={{ color: "#1A1514" }}
            data-testid="dresscode-label-black"
          >
            {t.dressCode.swatches.black}
          </motion.span>
        </div>

        {/* Tick marks indicating positions */}
        <div className="relative mx-auto max-w-3xl mt-3 grid grid-cols-3 items-start">
          <span className="justify-self-start w-[1px] h-4 bg-burgundy/40" />
          <span className="justify-self-center w-[1px] h-4 bg-warm-brown/40" />
          <span className="justify-self-end w-[1px] h-4 bg-ink/40" />
        </div>
      </div>
    </section>
  );
}
